import { useWizard } from "react-use-wizard";
import { TKeyOfDataWizardBuy, TNumberKeysOfIFillDataWizardBuy } from "../../..";
import FacilityTypeStep from "../../../../../../../shared/wizard/steps/facilityTypeStep";
import buySteps from "../../buySteps";

interface ISelectionByOwnSwapStep_5 {
  isNextStepDisabled: boolean;
  onChange: (data: number[], key: TNumberKeysOfIFillDataWizardBuy) => void;
  data: number[] | null;
  doublePrevStep: boolean;
  onReset: (key: TKeyOfDataWizardBuy[]) => void;
}

const SelectionByOwnSwapStep_5 = ({
  isNextStepDisabled,
  data,
  doublePrevStep,
  onChange,
  onReset,
}: ISelectionByOwnSwapStep_5) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(
      doublePrevStep
        ? buySteps.selectionSteps.swap.step_3
        : buySteps.selectionSteps.swap.step_4
    );
    onReset(["selectedFacilityTypeIds"]);
  };

  const handleNextStep = () => {
    goToStep(buySteps.selectionSteps.swap.step_6);
  };

  const handleChange = (selectedId: number) => {
    if (data?.includes(selectedId)) {
      onChange(
        data.filter((id) => id !== selectedId),
        "selectedFacilityTypeIds"
      );
      return;
    }
    onChange([selectedId], "selectedFacilityTypeIds");
  };

  return (
    <div>
      <FacilityTypeStep
        isNextStepDisabled={isNextStepDisabled}
        onChange={handleChange}
        onNextStep={handleNextStep}
        onPrevStep={handlePrevStep}
        data={data}
        mode="default"
      />
    </div>
  );
};

export default SelectionByOwnSwapStep_5;
